import { DriversProject, DriversProjectFields } from '../domain/driversProject/DriversProject';
import { DriversProjectEntry } from '../entries/DriversProjectEntry';

class DriversProjectMapper {
  static toDomain(props: DriversProjectEntry): DriversProject {
    const {
      id,
      fields,
      units,
      tasks_enabled,
      stop_reports_enabled,
      time_zone,
      service_duration,
      use_traffic,
      stop_grouping,
      transport_mode,
    } = props;

    return DriversProject.create(
      {
        fields: fields as DriversProjectFields,
        units: {
          distance: units.distance,
          weight: units.weight,
          volume: units.volume,
        },
        tasks_enabled,
        stop_reports_enabled,
        time_zone,
        service_duration,
        use_traffic,
        stop_grouping,
        transport_mode,
      },
      id
    );
  }
}

export default DriversProjectMapper;
